export default "__VITE_ASSET__CfS_JBmU__"